import { configureStore, DeepPartial, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { IState, reducers, rootSaga } from './ducks';

export function configRedux(initialState?: DeepPartial<IState>) {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    middleware: getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(sagaMiddleware),
    preloadedState: initialState,
    reducer: reducers
  });

  sagaMiddleware.run(rootSaga);
  return store;
}
